















































import Vue from 'vue';
import Component from 'vue-class-component';
import { Mutation, State, Getter, Action } from 'vuex-class';
import { client } from '../../store';
import { Maybe, IFile, IPageParams } from '@/models';
import { getUserFullName } from '@/helpers/functions';
const ns = { namespace: 'file' };
import paginationMixin from '@/mixins/pagintation';
@Component({
  methods: {
    getUserFullName,
  },
  components: {
    UIActions: () => import('@/components/UI/Actions.vue'),
  },
  data: () => ({
    namespace: 'file',
  }),
  mixins: [paginationMixin],
})
export default class FileList extends Vue {
  modalPath: Maybe<IFile> = null;
  @Action('getEntities', ns) getEntities: () => void;
  @Action('deleteEntities', ns) deleteEntities: () => void;
  @Getter('entitiesSlice', ns) entitiesSlice: IFile[];
  @State('pageParams', ns) pageParams: IPageParams;
  interval = null;
  headers = [
    { text: 'Название', value: 'name' },
    { text: 'Автор', value: 'creator' },
    { text: 'Время создания', value: 'created_at' },
  ];
  get viewer() {
    if (this.modalPath) {
      return this.modalPath.extension.match(/(doc\w?|xls\w?)/);
    } else return false;
  }
  selected = [];
  mounted() {
    this.getEntities();
  }
  previewFile(file: IFile) {
    if (file) {
      this.modalPath = file;
    }
  }
}
